<template>
    <login-form ref="form" :processing="processing" @o3-submit="onSubmit($event)"/>
</template>

<script>
import LoginForm from './LoginForm';
import {userSignIn} from '../api/user.api';

export default {
    components: {LoginForm},
    data() {
        return {
            processing: false,
        }
    },
    methods:    {
        onSubmit(data) {
            this.processing = true;
            userSignIn(data)
                .then(({data}) => {
                    this.$refs.form.reset();
                    this.$store.dispatch('user/setToken', data['jwt']);
                    this.$emit('logged');
                })
                .catch((message) => this.$dmv.notifyError(message))
                .finally(() => this.processing = false);
        }
    }
}
</script>
